module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.orderDetail.servCataId != '3010130') ? _c('div', {
    staticStyle: {
      "display": "flex",
      "flex-direction": "column",
      "width": "100%"
    }
  }, [_c('div', {
    staticClass: "order-input-wrap"
  }, [_c('base-tag', {
    attrs: {
      "label": "基本信息"
    }
  }), _vm._v(" "), (_vm.common.serv.get(_vm.orderDetail.servCataId).isTooth === '1') ? _c('y-tooth', {
    staticStyle: {
      "margin-bottom": "20px"
    },
    attrs: {
      "singleDataList": _vm.orderDetail.posSingleList,
      "bridgeDataList": _vm.orderDetail.posBridgeList,
      "isShow": true,
      "withServCataId": _vm.orderDetail.withServCataId
    },
    on: {
      "toothNum": _vm.toothNum
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "input-form-wrap-row"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "input-value"
  }, [_vm._v("\n          " + _vm._s(_vm.orderDetail.demContact) + "\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "input-form-wrap-row"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "input-value"
  }, [_vm._v("\n          " + _vm._s(_vm.orderDetail.demPhone) + "\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "input-form-wrap-row"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "input-value"
  }, [_vm._v("\n          " + _vm._s(_vm.orderDetail.demPatient) + "\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "input-form-wrap-row"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "input-value"
  }, [_vm._v("\n        " + _vm._s(_vm.orderDetail.demSex == '00' ? '男' : '女') + "\n      ")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "order-input-wrap"
  }, [_c('base-tag', {
    attrs: {
      "label": "设计费详情"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "input-form-wrap-row"
  }, [_c('div', {
    staticClass: "input-label"
  }, [_c('span', [_vm._v(_vm._s(_vm.orderDetail.servCataId == '1010410' ? '桥架' : '') + "数量：")])]), _vm._v(" "), _c('div', {
    staticClass: "input-value"
  }, [_vm._v("\n          " + _vm._s(_vm.orderCount) + "\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "input-form-wrap-row"
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "input-value"
  }, [_vm._v("\n          " + _vm._s(_vm.parseMoney(_vm.orderDetail.orderPrice)) + " 元\n        ")])]), _vm._v(" "), (_vm.fund > 0 && ((_vm.orderDetail.servCataId == '1010120' ||
    _vm.orderDetail.servCataId == '1010210' || _vm.orderDetail.servCataId == '1010220') && _vm.orderDetail.withServCataId !== '')) ? _c('div', {
    staticClass: "input-form-wrap-row"
  }, [_vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "input-value"
  }, [_vm._v("\n          " + _vm._s(_vm.fund) + "\n        ")])]) : _vm._e(), _vm._v(" "), (_vm.fund > 0 && ((_vm.orderDetail.servCataId == '1010120' ||
    _vm.orderDetail.servCataId == '1010210' || _vm.orderDetail.servCataId == '1010220') && _vm.orderDetail.withServCataId !== '')) ? _c('div', {
    staticClass: "input-form-wrap-row"
  }, [_vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "input-value"
  }, [_vm._v("\n          " + _vm._s(_vm.parseMoney(_vm.basePrice)) + " 元\n        ")])]) : _vm._e(), _vm._v(" "), (_vm.quantity > 0) ? _c('div', {
    staticClass: "input-form-wrap-row"
  }, [_vm._m(7), _vm._v(" "), _c('div', {
    staticClass: "input-value"
  }, [_vm._v("\n          " + _vm._s(_vm.quantity) + "\n        ")])]) : _vm._e(), _vm._v(" "), (_vm.quantity > 0) ? _c('div', {
    staticClass: "input-form-wrap-row"
  }, [_vm._m(8), _vm._v(" "), _c('div', {
    staticClass: "input-value"
  }, [_vm._v("\n          " + _vm._s(_vm.parseMoney(_vm.extraUnitPrice)) + " 元\n        ")])]) : _vm._e(), _vm._v(" "), (_vm.orderDetail.orderRushFee != 0) ? _c('div', {
    staticClass: "input-form-wrap-row"
  }, [_vm._m(9), _vm._v(" "), _c('div', {
    staticClass: "input-value"
  }, [_vm._v("\n        " + _vm._s(_vm.parseMoney(_vm.orderDetail.orderRushFee)) + "\n      ")])]) : _vm._e(), _vm._v(" "), (_vm.orderDetail.isEditScanModel == '1') ? _c('div', {
    staticClass: "input-form-wrap-row"
  }, [_vm._m(10), _vm._v(" "), _c('div', {
    staticClass: "input-value"
  }, [_vm._v("\n        " + _vm._s(_vm.parseMoney(_vm.common.serv.get(_vm.orderDetail.servCataId).editScanModelBprice)) + " 元\n      ")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "input-form-wrap-row"
  }, [_vm._m(11), _vm._v(" "), _c('div', {
    staticClass: "input-value"
  }, [_vm._v("\n        " + _vm._s(_vm.parseMoney(_vm.orderDetail.orderAmount)) + " 元\n      ")])])], 1), _vm._v(" "), (_vm.digitalize) ? _c('div', {
    staticClass: "order-input-wrap"
  }, [_c('base-tag', {
    class: _vm.orderDetail.servCataId == '1010410' && _vm.quantity ? 'design-param' : '',
    attrs: {
      "label": "设计信息"
    }
  }), _vm._v(" "), (_vm.orderDetail.desLevel != '99' && _vm.orderDetail.servCataId !== '1010410' && _vm.orderDetail.servCataId !== '1010510') ? _c('div', {
    staticClass: "input-form-wrap-row"
  }, [_vm._m(12), _vm._v(" "), (_vm.orderDetail.desLevel == '99') ? _c('div', {
    staticClass: "input-value"
  }, [_c('span', [_vm._v("认证级")])]) : _c('div', {
    staticClass: "input-value"
  }, [_c('dict-tag', {
    attrs: {
      "dict": "biz_des_level",
      "value": _vm.orderDetail.desLevel
    }
  })], 1)]) : _vm._e(), _vm._v(" "), (_vm.quantity > 0 || _vm.orderDetail.servCataId == '1010120') ? _c('div', {
    staticClass: "input-form-wrap-row"
  }, [_vm._m(13), _vm._v(" "), _c('div', {
    staticClass: "input-value"
  }, [_vm._v("\n          " + _vm._s(_vm.orderDetail.repairMaterial == '00' ? '氧化锆' : (_vm.orderDetail.repairMaterial == '01' ? '玻璃陶瓷' : '树脂')) + "\n        ")])]) : _vm._e(), _vm._v(" "), (_vm.quantity > 0 || _vm.orderDetail.servCataId == '1010120') ? _c('div', {
    staticClass: "input-form-wrap-row"
  }, [_vm._m(14), _vm._v(" "), _c('div', {
    staticClass: "input-value"
  }, [_c('dict-tag', {
    attrs: {
      "dict": "biz_yes_no",
      "value": _vm.orderDetail.posHole
    }
  })], 1)]) : _vm._e(), _vm._v(" "), (_vm.orderDetail.posHole == '1') ? _c('div', {
    staticClass: "input-form-wrap-row"
  }, [_vm._m(15), _vm._v(" "), _c('div', {
    staticClass: "input-value",
    style: (_vm.orderDetail.holeDiameter != 2.5 ? 'color:#2979ff;' : '')
  }, [_vm._v("\n          " + _vm._s(_vm.orderDetail.holeDiameter) + "mm\n        ")])]) : _vm._e(), _vm._v(" "), (['2010120', '2010210', '2010220', '2010320', '2010420', '1010120'].includes(_vm.orderDetail.servCataId) && ['0', ''].includes(_vm.orderDetail.withServCataId)) ? _c('div', {
    staticClass: "input-form-wrap-row"
  }, [_vm._m(16), _vm._v(" "), _c('div', {
    staticClass: "input-value"
  }, [_c('span', [_vm._v(_vm._s(_vm.orderDetail.designSoftware == '00' ? '通用' : 'exocad'))])])]) : _vm._e(), _vm._v(" "), ((_vm.fixed || _vm.orderDetail.servCataId == '1010120' || _vm.orderDetail.withServCataId.includes('1010120')) && _vm.CAMName) ? _c('div', {
    staticClass: "input-form-wrap-row"
  }, [_vm._m(17), _vm._v(" "), _c('div', {
    staticClass: "input-value"
  }, [_c('span', [_vm._v(_vm._s(_vm.CAMName))])])]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.common.serv.get(_vm.orderDetail.servCataId).isImpSystem == '1') ? _c('div', {
    staticClass: "order-input-wrap"
  }, [_c('base-tag', {
    attrs: {
      "label": "种植体信息"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "input-form-wrap-two"
  }, [_vm._m(18), _vm._v(" "), _c('div', {
    staticClass: "input-value"
  }, [_vm._v("\n          " + _vm._s(_vm.orderDetail.impSystem) + "\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "input-form-wrap-two"
  }, [_vm._m(19), _vm._v(" "), (_vm.orderDetail.impSystem != '99') ? _c('div', {
    staticClass: "input-value"
  }, [_vm._v("\n          " + _vm._s(_vm.orderDetail.impModel) + "\n        ")]) : _c('div', {
    staticClass: "input-value"
  }, [_c('span', [_vm._v(_vm._s(_vm.orderDetail.impExtra))])])]), _vm._v(" "), ((_vm.orderDetail.servCataId == '1010210' ||
    _vm.orderDetail.servCataId == '1010220' ||
    _vm.orderDetail.servCataId == '1010310' ||
    _vm.orderDetail.servCataId == '1010320' ||
    _vm.orderDetail.servCataId == '1010410' ||
    _vm.orderDetail.servCataId == '1010510')) ? _c('div', {
    staticClass: "input-form-wrap-row"
  }, [_vm._m(20), _vm._v(" "), _c('div', {
    staticClass: "input-value"
  }, [_vm._v("\n          " + _vm._s(_vm.orderDetail.scanningRod == '01' ? '口内扫描杆' : '口外扫描杆') + "\n        ")])]) : _vm._e(), _vm._v(" "), (_vm.orderDetail.scanningRodSupplier) ? _c('div', {
    staticClass: "input-form-wrap-row"
  }, [_vm._m(21), _vm._v(" "), _c('div', {
    staticClass: "input-value"
  }, [_vm._v("\n          " + _vm._s(_vm.orderDetail.scanningRodSupplier) + "\n        ")])]) : _vm._e(), _vm._v(" "), (_vm.common.serv.get(_vm.orderDetail.servCataId).isCollar === '1') ? _c('div', {
    staticClass: "input-form-wrap-row",
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_vm._m(22), _vm._v(" "), _c('div', {
    staticClass: "input-value"
  }, [_vm._v("\n          " + _vm._s(_vm.orderDetail.collar) + "\n        ")])]) : _vm._e(), _vm._v(" "), (_vm.orderDetail.servCataId == '1010510') ? _c('div', {
    class: _vm.orderDetail.subgingival.length > 7 ? 'input-form-wrap-fore' : 'input-form-wrap-row',
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_vm._m(23), _vm._v(" "), _c('div', {
    staticClass: "input-value"
  }, [_c('span', [_vm._v(_vm._s(_vm.orderDetail.subgingival))])])]) : _vm._e(), _vm._v(" "), (_vm.common.serv.get(_vm.orderDetail.servCataId).isBriCraft === '1') ? _c('div', {
    staticClass: "input-form-wrap-row",
    staticStyle: {
      "margin": "10px 0 0 5px",
      "width": "24.5%"
    }
  }, [_vm._m(24), _vm._v(" "), _c('div', {
    staticClass: "input-value",
    staticStyle: {
      "padding": "2px 5px"
    }
  }, [_c('dict-tag', {
    attrs: {
      "dict": "biz_bridge_craft",
      "value": _vm.orderDetail.briCraft
    }
  })], 1)]) : _vm._e(), _vm._v(" "), (_vm.common.serv.get(_vm.orderDetail.servCataId).isPlate === '1') ? _c('div', {
    staticClass: "input-form-wrap-row"
  }, [_vm._m(25), _vm._v(" "), _c('div', {
    staticClass: "input-value"
  }, [_c('dict-tag', {
    attrs: {
      "dict": "biz_plate_type",
      "value": _vm.orderDetail.plateType
    }
  })], 1)]) : _vm._e(), _vm._v(" "), ((_vm.orderDetail.servCataId == '1010698' || _vm.orderDetail.servCataId == '1010699' || _vm.orderDetail.servCataId == '1010700') && _vm.CAMName) ? _c('div', {
    staticClass: "input-form-wrap-row"
  }, [_vm._m(26), _vm._v(" "), _c('div', {
    staticClass: "input-value"
  }, [_c('span', [_vm._v(_vm._s(_vm.CAMName))])])]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.common.serv.get(_vm.orderDetail.servCataId).isParam === '1' || (_vm.orderDetail.withServCataId == '1010120' && _vm.orderDetail.servCataId == '1010410')) ? _c('div', {
    staticClass: "order-input-wrap"
  }, [_c('base-tag', {
    staticClass: "param-info",
    attrs: {
      "label": "参数信息"
    }
  }), _vm._v(" "), (_vm.orderDetail.plateThickness) ? _c('div', {
    staticClass: "input-form-wrap-row"
  }, [_vm._m(27), _vm._v(" "), _c('div', {
    staticClass: "input-value"
  }, [_c('span', {
    style: ({
      color: _vm.colorPlateThickness
    })
  }, [_vm._v(_vm._s(_vm.orderDetail.plateThickness) + " mm")])])]) : _vm._e(), _vm._v(" "), (_vm.orderDetail.teethModelDeviation) ? _c('div', {
    staticClass: "input-form-wrap-row"
  }, [_vm._m(28), _vm._v(" "), _c('div', {
    staticClass: "input-value"
  }, [_c('span', {
    style: ({
      color: _vm.colorTeethModelDeviation
    })
  }, [_vm._v(_vm._s(_vm.orderDetail.teethModelDeviation) + " mm")])])]) : _vm._e(), _vm._v(" "), (_vm.orderDetail.servCataId == '1010698' || _vm.orderDetail.servCataId == '1010699') ? _c('div', {
    staticClass: "input-form-wrap-row"
  }, [_vm._m(29), _vm._v(" "), _c('div', {
    staticClass: "input-value"
  }, [_c('span', {
    style: ({
      color: _vm.colorRecessedRetentionAmount
    })
  }, [_vm._v(_vm._s(_vm.orderDetail.recessedRetentionAmount) + " mm")])])]) : _vm._e(), _vm._v(" "), (_vm.orderDetail.guideRingCompensatio) ? _c('div', {
    staticClass: "input-form-wrap-row"
  }, [_vm._m(30), _vm._v(" "), _c('div', {
    staticClass: "input-value"
  }, [_c('span', {
    style: ({
      color: _vm.colorGuideRingCompensatio
    })
  }, [_vm._v(_vm._s(_vm.orderDetail.guideRingCompensatio) + " mm")])])]) : _vm._e(), _vm._v(" "), (_vm.orderDetail.adhesiveGap) ? _c('div', {
    staticClass: "input-form-wrap-row"
  }, [_vm._m(31), _vm._v(" "), _c('div', {
    staticClass: "input-value"
  }, [_c('span', {
    style: ({
      color: _vm.colorAdhesiveGap
    })
  }, [_vm._v(_vm._s(_vm.orderDetail.adhesiveGap) + " mm")])])]) : _vm._e(), _vm._v(" "), (_vm.orderDetail.adhesiveExtraGap) ? _c('div', {
    staticClass: "input-form-wrap-two"
  }, [_vm._m(32), _vm._v(" "), _c('div', {
    staticClass: "input-value"
  }, [_c('span', {
    style: ({
      color: _vm.colorAdhesiveExtraGap
    })
  }, [_vm._v(_vm._s(_vm.orderDetail.adhesiveExtraGap) + " mm")])])]) : _vm._e(), _vm._v(" "), (_vm.orderDetail.minThick && _vm.orderDetail.designSoftware == '00') ? _c('div', {
    staticClass: "input-form-wrap-row"
  }, [_vm._m(33), _vm._v(" "), _c('div', {
    staticClass: "input-value"
  }, [_c('span', {
    style: ({
      color: _vm.colorMinThick
    })
  }, [_vm._v(_vm._s(_vm.orderDetail.minThick) + " mm")])])]) : _vm._e(), _vm._v(" "), (_vm.orderDetail.wallHeight) ? _c('div', {
    staticClass: "input-form-wrap-row"
  }, [_vm._m(34), _vm._v(" "), _c('div', {
    staticClass: "input-value"
  }, [_c('span', {
    style: ({
      color: _vm.colorWallHeight
    })
  }, [_vm._v(_vm._s(_vm.orderDetail.wallHeight) + " mm")])])]) : _vm._e(), _vm._v(" "), (_vm.orderDetail.edgeLineDistance) ? _c('div', {
    staticClass: "input-form-wrap-distance"
  }, [_vm._m(35), _vm._v(" "), _c('div', {
    staticClass: "input-value"
  }, [_c('span', {
    style: ({
      color: _vm.colorEdgeLineDistance
    })
  }, [_vm._v(_vm._s(_vm.orderDetail.edgeLineDistance) + " mm")])])]) : _vm._e(), _vm._v(" "), (_vm.orderDetail.smoothDistance) ? _c('div', {
    staticClass: "input-form-wrap-row"
  }, [_vm._m(36), _vm._v(" "), _c('div', {
    staticClass: "input-value"
  }, [_c('span', {
    style: ({
      color: _vm.colorSmoothDistance
    })
  }, [_vm._v(_vm._s(_vm.orderDetail.smoothDistance) + " mm")])])]) : _vm._e(), _vm._v(" "), (_vm.orderDetail.burRadius) ? _c('div', {
    staticClass: "input-form-wrap-row"
  }, [_vm._m(37), _vm._v(" "), _c('div', {
    staticClass: "input-value"
  }, [_c('span', {
    style: ({
      color: _vm.colorBurRadius
    })
  }, [_vm._v(_vm._s(_vm.orderDetail.burRadius) + " mm")])])]) : _vm._e(), _vm._v(" "), (_vm.orderDetail.burGapOffset) ? _c('div', {
    staticClass: "input-form-wrap-row"
  }, [_vm._m(38), _vm._v(" "), _c('div', {
    staticClass: "input-value"
  }, [_c('span', {
    style: ({
      color: _vm.colorBurGapOffset
    })
  }, [_vm._v(_vm._s(_vm.orderDetail.burGapOffset) + " mm")])])]) : _vm._e(), _vm._v(" "), (_vm.orderDetail.edgeLineOffset) ? _c('div', {
    staticClass: "input-form-wrap-row"
  }, [_vm._m(39), _vm._v(" "), _c('div', {
    staticClass: "input-value"
  }, [_c('span', {
    style: ({
      color: _vm.colorEdgeLineOffset
    })
  }, [_vm._v(_vm._s(_vm.orderDetail.edgeLineOffset) + " mm")])])]) : _vm._e(), _vm._v(" "), (_vm.orderDetail.stretchOffset) ? _c('div', {
    staticClass: "input-form-wrap-row"
  }, [_vm._m(40), _vm._v(" "), _c('div', {
    staticClass: "input-value"
  }, [_c('span', {
    style: ({
      color: _vm.colorStretchOffset
    })
  }, [_vm._v(_vm._s(_vm.orderDetail.stretchOffset) + " mm")])])]) : _vm._e(), _vm._v(" "), (_vm.orderDetail.angleOffset) ? _c('div', {
    staticClass: "input-form-wrap-row"
  }, [_vm._m(41), _vm._v(" "), _c('div', {
    staticClass: "input-value"
  }, [_c('span', {
    style: ({
      color: _vm.colorAngleOffset
    })
  }, [_vm._v(_vm._s(_vm.orderDetail.angleOffset) + " 度")])])]) : _vm._e(), _vm._v(" "), (['2010210', '2010220'].includes(_vm.orderDetail.servCataId) && _vm.orderDetail.designSoftware == '00') ? _c('div', {
    staticClass: "input-form-wrap-one"
  }, [_vm._m(42), _vm._v(" "), _c('div', {
    staticClass: "input-value"
  }, [_c('span', {
    style: ({
      color: _vm.colorTongueSideOffset
    })
  }, [_vm._v(_vm._s(_vm.orderDetail.isTongueSide == '0' ? '无' : '有'))])])]) : _vm._e(), _vm._v(" "), (_vm.orderDetail.isTongueSide && _vm.orderDetail.isTongueSide == '1' && _vm.orderDetail.sideOffset == '0') ? _c('div', {
    staticClass: "input-form-wrap-row"
  }, [_vm._m(43), _vm._v(" "), _c('div', {
    staticClass: "input-value"
  }, [_c('span', {
    style: ({
      color: _vm.colorTongueSideOffset
    })
  }, [_vm._v(_vm._s(_vm.orderDetail.tongueSideOffset) + " mm")])])]) : _vm._e(), _vm._v(" "), (_vm.orderDetail.isTongueSide && _vm.orderDetail.isTongueSide == '1' && _vm.orderDetail.sideOffset == '1') ? _c('div', {
    staticClass: "input-form-wrap-row"
  }, [_vm._m(44), _vm._v(" "), _c('div', {
    staticClass: "input-value"
  }, [_c('span', {
    style: ({
      color: _vm.colorCircleSideOffset
    })
  }, [_vm._v(_vm._s(_vm.orderDetail.circleSideOffset) + " mm")])])]) : _vm._e(), _vm._v(" "), (_vm.orderDetail.polymerization) ? _c('div', {
    staticClass: "input-form-wrap-row",
    staticStyle: {
      "height": "32px"
    }
  }, [_vm._m(45), _vm._v(" "), _c('div', {
    staticClass: "input-value"
  }, [_c('span', {
    style: ({
      color: _vm.colorPolymerization
    })
  }, [_vm._v(_vm._s(_vm.orderDetail.polymerization) + " 度")])])]) : _vm._e(), _vm._v(" "), (_vm.orderDetail.baseHeight) ? _c('div', {
    staticClass: "input-form-wrap-row"
  }, [_vm._m(46), _vm._v(" "), _c('div', {
    staticClass: "input-value"
  }, [_c('span', {
    style: ({
      color: _vm.colorBaseHeight
    })
  }, [_vm._v(_vm._s(_vm.orderDetail.baseHeight) + " mm")])])]) : _vm._e(), _vm._v(" "), (_vm.orderDetail.shoulderWidth) ? _c('div', {
    staticClass: "input-form-wrap-row"
  }, [_vm._m(47), _vm._v(" "), _c('div', {
    staticClass: "input-value"
  }, [_c('span', {
    style: ({
      color: _vm.colorShoulderWidth
    })
  }, [_vm._v(_vm._s(_vm.orderDetail.shoulderWidth) + " mm")])])]) : _vm._e(), _vm._v(" "), (_vm.orderDetail.shoulderAngle) ? _c('div', {
    staticClass: "input-form-wrap-row"
  }, [_vm._m(48), _vm._v(" "), _c('div', {
    staticClass: "input-value"
  }, [_c('span', {
    style: ({
      color: _vm.colorShoulderAngle
    })
  }, [_vm._v(_vm._s(_vm.orderDetail.shoulderAngle) + " 度")])])]) : _vm._e(), _vm._v(" "), (_vm.abutment && _vm.orderDetail.supragingival) ? _c('div', {
    staticClass: "input-form-wrap-one"
  }, [_vm._m(49), _vm._v(" "), _c('div', {
    staticClass: "input-value"
  }, [_c('span', {
    style: ({
      color: _vm.colorGingiva
    })
  }, [_vm._v(_vm._s(_vm.orderDetail.gingiva == '01' ? '龈下' : (_vm.orderDetail.gingiva == '02' ? '齐龈' : '龈上')) + " ")]), _vm._v(" "), _c('span', {
    style: ({
      color: _vm.colorSupragingival
    })
  }, [_vm._v(_vm._s(_vm.orderDetail.gingiva == '02' ? '' : _vm.orderDetail.supragingival + 'mm'))])])]) : _vm._e(), _vm._v(" "), (_vm.orderDetail.occlusalClearance) ? _c('div', {
    staticClass: "input-form-wrap-row"
  }, [_vm._m(50), _vm._v(" "), _c('div', {
    staticClass: "input-value"
  }, [_c('span', {
    style: ({
      color: _vm.colorocclusalClearance
    })
  }, [_vm._v(_vm._s(_vm.orderDetail.occlusalClearance) + " mm")])])]) : _vm._e(), _vm._v(" "), (_vm.orderDetail.adjacencyGap) ? _c('div', {
    staticClass: "input-form-wrap-row"
  }, [_vm._m(51), _vm._v(" "), _c('div', {
    staticClass: "input-value"
  }, [_c('span', {
    style: ({
      color: _vm.colorAdjacencyGap
    })
  }, [_vm._v(_vm._s(_vm.orderDetail.adjacencyGap) + " mm")])])]) : _vm._e(), _vm._v(" "), (_vm.orderDetail.designSoftware == '10') ? _c('div', {
    staticClass: "input-form-wrap-row"
  }, [_vm._m(52), _vm._v(" "), _c('div', {
    staticClass: "input-value"
  }, [_c('span', {
    style: ({
      color: _vm.colorInnerCrownThickness
    })
  }, [_vm._v(_vm._s(_vm.orderDetail.innerCrownThickness) + " mm")])])]) : _vm._e(), _vm._v(" "), (_vm.orderDetail.designSoftware == '10') ? _c('div', {
    staticClass: "input-form-wrap-row"
  }, [_vm._m(53), _vm._v(" "), _c('div', {
    staticClass: "input-value"
  }, [_c('span', {
    style: ({
      color: _vm.colorOcclusionSpace
    })
  }, [_vm._v(_vm._s(_vm.orderDetail.occlusionSpace) + " mm")])])]) : _vm._e(), _vm._v(" "), (_vm.orderDetail.designSoftware == '10') ? _c('div', {
    staticClass: "input-form-wrap-row"
  }, [_vm._m(54), _vm._v(" "), _c('div', {
    staticClass: "input-value"
  }, [_c('span', {
    style: ({
      color: _vm.colorAdhesiveThickness
    })
  }, [_vm._v(_vm._s(_vm.orderDetail.adhesiveThickness) + " mm")])])]) : _vm._e(), _vm._v(" "), (_vm.orderDetail.designSoftware == '10') ? _c('div', {
    staticClass: "input-form-wrap-row"
  }, [_vm._m(55), _vm._v(" "), _c('div', {
    staticClass: "input-value"
  }, [_c('span', {
    style: ({
      color: _vm.colorGingivalThickness
    })
  }, [_vm._v(_vm._s(_vm.orderDetail.gingivalThickness) + " mm")])])]) : _vm._e(), _vm._v(" "), (_vm.orderDetail.designSoftware == '10') ? _c('div', {
    staticClass: "input-form-wrap-row"
  }, [_vm._m(56), _vm._v(" "), _c('div', {
    staticClass: "input-value"
  }, [_c('span', {
    style: ({
      color: _vm.colorDistanceAdjacentTooth
    })
  }, [_vm._v(_vm._s(_vm.orderDetail.distanceAdjacentTooth) + " mm")])])]) : _vm._e(), _vm._v(" "), (_vm.orderDetail.designSoftware == '10') ? _c('div', {
    staticClass: "input-form-wrap-row"
  }, [_vm._m(57), _vm._v(" "), _c('div', {
    staticClass: "input-value"
  }, [_c('span', {
    style: ({
      color: _vm.colorMarginLineShift
    })
  }, [_vm._v(_vm._s(_vm.orderDetail.marginLineShift) + " mm")])])]) : _vm._e(), _vm._v(" "), (_vm.orderDetail.designSoftware == '10') ? _c('div', {
    staticClass: "input-form-wrap-row"
  }, [_vm._m(58), _vm._v(" "), _c('div', {
    staticClass: "input-value"
  }, [_c('span', {
    style: ({
      color: _vm.colorCementGap
    })
  }, [_vm._v(_vm._s(_vm.orderDetail.cementGap) + " mm")])])]) : _vm._e(), _vm._v(" "), (_vm.orderDetail.designSoftware == '10') ? _c('div', {
    staticClass: "input-form-wrap-row"
  }, [_vm._m(59), _vm._v(" "), _c('div', {
    staticClass: "input-value"
  }, [_c('span', {
    style: ({
      color: _vm.colorFromMarginLine
    })
  }, [_vm._v(_vm._s(_vm.orderDetail.fromMarginLine) + " mm")])])]) : _vm._e(), _vm._v(" "), (_vm.orderDetail.designSoftware == '10') ? _c('div', {
    staticClass: "input-form-wrap-row"
  }, [_vm._m(60), _vm._v(" "), _c('div', {
    staticClass: "input-value"
  }, [_c('span', {
    style: ({
      color: _vm.colorEdgeHorizontalWidth
    })
  }, [_vm._v(_vm._s(_vm.orderDetail.edgeHorizontalWidth) + " mm")])])]) : _vm._e(), _vm._v(" "), (_vm.orderDetail.designSoftware == '10') ? _c('div', {
    staticClass: "input-form-wrap-row"
  }, [_vm._m(61), _vm._v(" "), _c('div', {
    staticClass: "input-value"
  }, [_c('span', {
    style: ({
      color: _vm.colorEdgeTiltWidth
    })
  }, [_vm._v(_vm._s(_vm.orderDetail.edgeTiltWidth) + " mm")])])]) : _vm._e(), _vm._v(" "), (_vm.orderDetail.designSoftware == '10') ? _c('div', {
    staticClass: "input-form-wrap-row"
  }, [_vm._m(62), _vm._v(" "), _c('div', {
    staticClass: "input-value"
  }, [_c('span', {
    style: ({
      color: _vm.colorEdgeInclinationAngle
    })
  }, [_vm._v(_vm._s(_vm.orderDetail.edgeInclinationAngle) + " 度")])])]) : _vm._e(), _vm._v(" "), (_vm.orderDetail.designSoftware == '10') ? _c('div', {
    staticClass: "input-form-wrap-row"
  }, [_vm._m(63), _vm._v(" "), _c('div', {
    staticClass: "input-value"
  }, [_c('span', {
    style: ({
      color: _vm.colorEdgeVerticalHeight
    })
  }, [_vm._v(_vm._s(_vm.orderDetail.edgeVerticalHeight) + " mm")])])]) : _vm._e(), _vm._v(" "), (_vm.orderDetail.designSoftware == '10') ? _c('div', {
    staticClass: "input-form-wrap-row"
  }, [_vm._m(64), _vm._v(" "), _c('div', {
    staticClass: "input-value"
  }, [_c('span', {
    style: ({
      color: _vm.colorAxialExtraClearance
    })
  }, [_vm._v(_vm._s(_vm.orderDetail.axialExtraClearance) + " mm")])])]) : _vm._e(), _vm._v(" "), (_vm.orderDetail.designSoftware == '10') ? _c('div', {
    staticClass: "input-form-wrap-row"
  }, [_vm._m(65), _vm._v(" "), _c('div', {
    staticClass: "input-value"
  }, [_c('span', {
    style: ({
      color: _vm.colorRadialExtraClearance
    })
  }, [_vm._v(_vm._s(_vm.orderDetail.radialExtraClearance) + " mm")])])]) : _vm._e(), _vm._v(" "), (_vm.orderDetail.designSoftware == '10') ? _c('div', {
    staticClass: "input-form-wrap-row"
  }, [_vm._m(66), _vm._v(" "), _c('div', {
    staticClass: "input-value"
  }, [_c('span', {
    style: ({
      color: _vm.colorProhibitedFillingMargin
    })
  }, [_vm._v(_vm._s(_vm.orderDetail.prohibitedFillingMargin) + " mm")])])]) : _vm._e(), _vm._v(" "), (_vm.orderDetail.designSoftware == '10') ? _c('div', {
    staticClass: "input-form-wrap-row"
  }, [_vm._m(67), _vm._v(" "), _c('div', {
    staticClass: "input-value"
  }, [_c('span', {
    style: ({
      color: _vm.colorMarginCementWidth
    })
  }, [_vm._v(_vm._s(_vm.orderDetail.marginCementWidth) + " mm")])])]) : _vm._e(), _vm._v(" "), (_vm.orderDetail.designSoftware == '10') ? _c('div', {
    staticClass: "input-form-wrap-row"
  }, [_vm._m(68), _vm._v(" "), _c('div', {
    staticClass: "input-value"
  }, [_c('span', {
    style: ({
      color: _vm.colorTopAdhesiveWidth
    })
  }, [_vm._v(_vm._s(_vm.orderDetail.topAdhesiveWidth) + " mm")])])]) : _vm._e(), _vm._v(" "), (_vm.orderDetail.designSoftware == '10') ? _c('div', {
    staticClass: "input-form-wrap-row"
  }, [_vm._m(69), _vm._v(" "), _c('div', {
    staticClass: "input-value"
  }, [_c('span', {
    style: ({
      color: _vm.colorCrossSectionalAreaConnector
    })
  }, [_vm._v(_vm._s(_vm.orderDetail.crossSectionalAreaConnector) + " mm²")])])]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.orderDetail.impSystem && _vm.common.serv.get(_vm.orderDetail.servCataId).isImpSystem !== '1') ? _c('div', {
    staticClass: "order-input-wrap"
  }, [_c('base-tag', {
    attrs: {
      "label": _vm.orderDetail.servCataId == '1010120' && _vm.orderDetail.withServCataId != '' ? '基台设计需求' : '种植体信息'
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "input-form-wrap-two"
  }, [_vm._m(70), _vm._v(" "), _c('div', {
    staticClass: "input-value"
  }, [_vm._v("\n            " + _vm._s(_vm.orderDetail.impSystem) + "\n          ")])]), _vm._v(" "), _c('div', {
    staticClass: "input-form-wrap-two"
  }, [_vm._m(71), _vm._v(" "), (_vm.orderDetail.impSystem != '99') ? _c('div', {
    staticClass: "input-value"
  }, [_vm._v("\n            " + _vm._s(_vm.orderDetail.impModel) + "\n          ")]) : _c('div', {
    staticClass: "input-value"
  }, [_c('span', [_vm._v(_vm._s(_vm.orderDetail.impExtra))])])]), _vm._v(" "), _c('div', {
    staticClass: "input-form-wrap-row"
  }, [_vm._m(72), _vm._v(" "), _c('div', {
    staticClass: "input-value"
  }, [_vm._v("\n            " + _vm._s(_vm.orderDetail.scanningRod == '01' ? '口内扫描杆' : '口外扫描杆') + "\n          ")])]), _vm._v(" "), (_vm.orderDetail.scanningRodSupplier) ? _c('div', {
    staticClass: "input-form-wrap-row"
  }, [_vm._m(73), _vm._v(" "), _c('div', {
    staticClass: "input-value"
  }, [_vm._v("\n            " + _vm._s(_vm.orderDetail.scanningRodSupplier) + "\n          ")])]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.orderDetail.surgicalBoxSupplier) ? _c('div', {
    staticClass: "order-input-wrap"
  }, [_c('base-tag', {
    attrs: {
      "label": "器械规格"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "input-form-wrap-fore",
    style: (_vm.orderDetail.surgicalBoxSupplier.length <= 7 ? 'width:25%;' : '')
  }, [_vm._m(74), _vm._v(" "), _c('div', {
    staticClass: "input-value"
  }, [_vm._v("\n          " + _vm._s(_vm.orderDetail.surgicalBoxSupplier) + "\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "input-form-wrap-fore",
    style: (_vm.orderDetail.surgicalBoxSupplier.length <= 7 ? 'width:25%;' : '')
  }, [_vm._m(75), _vm._v(" "), _c('div', {
    staticClass: "input-value"
  }, [_vm._v("\n          " + _vm._s(_vm.orderDetail.plantModel) + "\n        ")])])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "order-input-wrap"
  }, [_c('base-tag', {
    attrs: {
      "label": "备注信息"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "input-textarea"
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "autosize": {
        minRows: 2,
        maxRows: 20
      },
      "disabled": "",
      "readonly": ""
    },
    model: {
      value: (_vm.orderDetail.orderRemark),
      callback: function($$v) {
        _vm.$set(_vm.orderDetail, "orderRemark", $$v)
      },
      expression: "orderDetail.orderRemark"
    }
  })], 1)], 1)]) : _vm._e(), _vm._v(" "), (_vm.orderDetail.servCataId == '3010130') ? _c('div', [_c('OrthoOrderDetail', {
    attrs: {
      "orderDetail": _vm.orderDetail
    }
  })], 1) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-label"
  }, [_c('span', [_vm._v("下单名称：")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-label"
  }, [_c('span', [_vm._v("联系方式：")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-label"
  }, [_c('span', [_vm._v("患者姓名：")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-label"
  }, [_c('span', [_vm._v("患者性别：")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-label"
  }, [_c('span', [_vm._v("单价：")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-label"
  }, [_c('span', [_vm._v("基台数量：")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-label"
  }, [_c('span', [_vm._v("基台单价：")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-label"
  }, [_c('span', [_vm._v("上部冠数量：")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-label"
  }, [_c('span', [_vm._v("上部冠单价：")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-label"
  }, [_c('span', [_vm._v("加急费：")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-label"
  }, [_c('span', [_vm._v("口扫模型编辑：")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-label"
  }, [_c('span', [_vm._v("总价：")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-label"
  }, [_c('span', [_vm._v("设计师级别：")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-label"
  }, [_c('span', [_vm._v("修复体材质：")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-label"
  }, [_c('span', [_vm._v("冠部是否开孔：")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-label"
  }, [_c('span', [_vm._v("冠部是否开孔：")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-label"
  }, [_c('span', [_vm._v("设计软件：")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-label"
  }, [_c('span', [_vm._v("CAM制造设备：")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-label"
  }, [_c('span', [_vm._v("植体系统 ：")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-label"
  }, [_c('span', [_vm._v("植体型号 ：")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-label"
  }, [_c('span', [_vm._v("扫描杆：")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-label"
  }, [_c('span', [_vm._v("扫描杆供应商：")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-label"
  }, [_c('span', [_vm._v("杆卡类型：")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-label",
    staticStyle: {
      "width": "112px"
    }
  }, [_c('span', [_vm._v("精密附件及型号：")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-label-bridge"
  }, [_c('span', [_vm._v("桥架上部修复工艺 ：")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-label"
  }, [_c('span', [_vm._v("导板类型 ：")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-label"
  }, [_c('span', [_vm._v("CAM制造设备：")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-label"
  }, [_c('span', [_vm._v("导板厚度：")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-label"
  }, [_c('span', [_vm._v("牙齿/模型偏移：")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-label"
  }, [_c('span', [_vm._v("倒凹保留量：")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-label"
  }, [_c('span', [_vm._v("从导环的补偿：")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-label"
  }, [_c('span', [_vm._v("黏着剂间隙：")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-label"
  }, [_c('span', [_vm._v("额外黏着剂间隙：")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-label"
  }, [_c('span', [_vm._v("最小厚度：")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-label"
  }, [_c('span', [_vm._v("壁高度：")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-label"
  }, [_c('span', [_vm._v("到边缘线的距离：")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-label"
  }, [_c('span', [_vm._v("平滑距离：")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-label"
  }, [_c('span', [_vm._v("车针半径：")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-label"
  }, [_c('span', [_vm._v("车针补偿间距：")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-label"
  }, [_c('span', [_vm._v("边缘线补偿：")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-label"
  }, [_c('span', [_vm._v("延伸补偿：")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-label"
  }, [_c('span', [_vm._v("补偿角度：")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-label"
  }, [_c('span', [_vm._v("舌侧边补偿(宽度)：")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-label"
  }, [_c('span', [_vm._v("舌侧边：")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-label"
  }, [_c('span', [_vm._v("360度边：")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-label"
  }, [_c('span', [_vm._v("聚合度\t：")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-label"
  }, [_c('span', [_vm._v("基台不低于\t：")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-label"
  }, [_c('span', [_vm._v("肩台宽度\t：")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-label"
  }, [_c('span', [_vm._v("肩台角度\t：")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-label"
  }, [_c('span', [_vm._v("肩台与牙龈位置：")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-label"
  }, [_c('span', [_vm._v("咬合间隙：")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-label"
  }, [_c('span', [_vm._v("邻接间隙：")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-label"
  }, [_c('span', [_vm._v("内冠厚度：")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-label"
  }, [_c('span', [_vm._v("咬合空间：")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-label"
  }, [_c('span', [_vm._v("粘接剂厚度：")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-label"
  }, [_c('span', [_vm._v("牙龈厚度：")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-label"
  }, [_c('span', [_vm._v("到邻牙距离：")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-label"
  }, [_c('span', [_vm._v("边缘线下移：")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-label"
  }, [_c('span', [_vm._v("粘接间隙：")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-label"
  }, [_c('span', [_vm._v("从边缘线：")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-label"
  }, [_c('span', [_vm._v("边缘水平宽度：")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-label"
  }, [_c('span', [_vm._v("边缘倾斜宽度：")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-label"
  }, [_c('span', [_vm._v("边缘倾斜角度：")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-label"
  }, [_c('span', [_vm._v("边缘垂直高度：")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-label"
  }, [_c('span', [_vm._v("轴向额外间隙：")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-label"
  }, [_c('span', [_vm._v("径向额外间隙：")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-label"
  }, [_c('span', [_vm._v("禁止填除边缘：")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-label"
  }, [_c('span', [_vm._v("边缘粘接剂宽度：")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-label"
  }, [_c('span', [_vm._v("顶部粘接剂宽度：")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-label"
  }, [_c('span', [_vm._v("连接杆横截面积：")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-label"
  }, [_c('span', [_vm._v("植体系统 ：")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-label"
  }, [_c('span', [_vm._v("植体型号 ：")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-label"
  }, [_c('span', [_vm._v("扫描杆：")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-label"
  }, [_c('span', [_vm._v("扫描杆供应商：")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-label"
  }, [_c('span', [_vm._v("手术器械盒供应商 ：")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-label"
  }, [_c('span', [_vm._v("导环规格和型号 ：")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-36906338","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Order/detailOrder.vue
// module id = 634
// module chunks = 0